//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Dialog } from 'vant'
import { TYPE_NAMES } from '@/public/config/requestType'
import { STATUS } from '@/public/config/statusConf'
import GENDER from '@/public/config/genderConf'

export default {
  components: { 'v-dialog': Dialog.Component },

  filters: {
    reqtype (val) {
      return TYPE_NAMES[val] || '其他'
    },
    outStatusName (val) {
      return val ? '离校' : '否'
    },

    // 非离校请假销假：0-无需销假；1-需要销假
    notOutReportDisplay (type) {
      if (type) {
        return '离校、非离校请假需要销假'
      } else {
        return '离校请假需要销假，非离校请假无需销假'
      }
    },
  },

  props: {
    info: {
      type: Object,
      default: () => ({}),
    },

    notOutReport: {
      type: Object,
      default: () => { },
    },
  },

  data () {
    return { reportVisible: false }
  },

  computed: {
    isPending () {
      return this.info.ownStatus && this.info.status === STATUS.PENDING
    },

    leaveSchoolTextClass () {
      return this.outStatusBoolean && this.info.gender === GENDER.FEMALE ? 'font-warning' : 'font-normal'
    },

    outStatusBoolean () {
      return this.info.outStatus
    },

    isEarlyEnd () {
      return this.info.isEarlyEnd
    },

    actLeaveTime () {
      const { actStatus, startTime, actEndTime, actEndTimeDesc } = this.info

      return actStatus === '8' ? (actEndTimeDesc === '' ? '0天  休假未开始已提前结束或提前销假' : (`${startTime} ~ ${actEndTime}（共${actEndTimeDesc}）`)) : '-'
    },

    actLeaveTimeStyle () {
      return this.isEarlyEnd === '1' ? 'color: #FF9900;' : ''
    },
  },

  methods: {
    showDetailModal () {
      this.reportVisible = true
    },
  },
}
